<template>
    <div class="row" style="margin-top:-25px">
        <div class="col-sm-12 col-md-12 col-lg-12 text-left">
            <h2 style="font-size: 40px; font-weight: 700; line-height: 48px;" class="mb-0 mt-2">MD5 Hash Identification</h2>
            <p class="mb-0 mt-2" style="opacity: 0.8;">
                Upload or enter MD5 hashes to retrieve user data instantly.
            </p>
        </div>
        <div
            v-if="false && this.$global.settingMenuShow && !this.$global.systemUser && this.$global.creditcardsetup && this.$global.stripeaccountconnected && this.$store.getters.userData.user_type != 'client'" 
            class="col-sm-12 col-md-12 col-lg-12 form-group has-label pull-left mt-4">
            <SelectClientDropdownDashboard :isNotRefresh="true" @on-filter="onChangeFilter"></SelectClientDropdownDashboard>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 mt-3">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 mt-3">
                    <div class="row d-flex align-items-stretch">
                        <div class="col-sm-12 col-md-12 col-lg-12 d-flex">
                            <card style="position: relative;">
                                <div class="overlay-card-theme" v-if="!isClientFilterActive">
                                    <span class="text-overlay">Please select a client first</span>
                                </div>

                                <div class="d-flex align-items-center h-100">
                                    <i class="fas fa-wallet fa-2x mr-3"></i>
                                    <div>
                                        <p class="mb-1" style="opacity: 0.8;">Your Balance</p>
                                        <i v-if="isFetchBalanceAmount" class="fas fa-spinner fa-spin" style="font-size: 20px;"></i>
                                        <h4 v-else class="mb-0" style="font-weight: 600;">${{ $global.balanceDirectPayment }}</h4>
                                    </div>
                                </div>
                            </card>
                        </div>
                        <div v-if="false" class="col-sm-12 col-md-12 col-lg-12 d-flex">
                            <card style="position: relative;">
                                <div class="overlay-card-theme" v-if="!isClientFilterActive">
                                    <span class="text-overlay">Please select a client first</span>
                                </div>
                                <div class="d-flex justify-content-between flex-wrap align-items-center">
                                    <p class="mb-1" style="opacity: 0.8;">Click the "Financial Settings" button to configure the cost per MD5.</p>
                                    <base-button 
                                        type="button" 
                                        @click.native="onOpenFinancialSettingsClean"
                                        :disabled="isFetchFinancialSettings">
                                        Financial Settings
                                        <i v-if="isFetchFinancialSettings" class="fas fa-spinner fa-spin ml-2" style="font-size: 16px;"></i>
                                    </base-button>
                                </div>
                            </card>
                        </div>

                        <div v-if="false" class="col-sm-12 col-md-12 col-lg-6 d-flex justify-content-around relative" style="cursor: no-drop;">                                
                            <card class="disabled relative" :shadow="campaignInformationData.includes('basic') ? 'always' : 'hover'" :class="{ 'campaign-cleanid-active': campaignInformationData.includes('basic')}" @click.native="onChangeCampaignInformationData('basic')">
                                <span class="label__active" v-if="campaignInformationData.includes('basic')">active</span>
                                
                                <div class="overlay-card-theme" v-if="!isClientFilterActive">
                                    <span class="text-overlay">Please select a client first</span>
                                </div>
                                <div>
                                    <i class="fas fa-user" style="font-size: 20px; margin-bottom: 15px;"></i>
                                </div>
                                <p class="mb-1" style="opacity: 0.8;">Basic Information</p>
                                <p>General data used for identification and standard purposes.</p>
                            </card>
                        </div>
                        <div v-if="false" class="col-sm-12 col-md-12 col-lg-6 d-flex relative justify-content-center" style="cursor: pointer;">
                            <!-- <card style="cursor: pointer; position: relative;" :shadow="campaignInformationData.includes('advanced') ? 'always' : 'hover'" :class="{ 'campaign-cleanid-active': campaignInformationData.includes('advanced'), 'disabled': !isClientFilterActive }" @click.native="onChangeCampaignInformationData('advanced')"> -->
                            <card class="relative" :shadow="campaignInformationData.includes('advanced') ? 'always' : 'hover'" :class="{ 'campaign-cleanid-active': campaignInformationData.includes('advanced')}" @click.native="onChangeCampaignInformationData('advanced')">
                                <span class="label__active" v-if="campaignInformationData.includes('advanced')">active</span>
                                <div class="overlay-card-theme" v-if="!isClientFilterActive">
                                    <span class="text-overlay">Please select a client first</span>
                                </div>
                                <i class="fa-solid fa-angles-up" style="font-size: 20px; margin-bottom: 15px;"></i>
                                <p>Advance Information</p>
                                <p >Additional data for advanced features and specific needs.</p>
                            </card>
                        </div>
                        <div v-if="false" class="col-sm-12 col-md-12 col-lg-4 d-flex relative justify-content-center">
                            <card style="cursor: pointer;" :shadow="campaignInformationData.includes('b2b') ? 'always' : 'hover'" class="disabled" :class="{ 'campaign-cleanid-active': campaignInformationData.includes('b2b') }" @click.native="onChangeCampaignInformationData('b2b')">
                                <span class="label__active" v-if="campaignInformationData.includes('b2b')">active</span>
                                <div class="overlay-card-theme">
                                    <span class="text-overlay">Coming Soon</span>
                                </div>
                                <i class="fa-solid fa-building" style="font-size: 20px; margin-bottom: 15px;"></i>
                                <p>B2B Information</p>
                                <p >Information tailored for company-to-company transactions.</p>
                            </card>
                        </div>
                    </div>

                    <!-- <card class="relative" v-if="campaignInformationData.includes('basic')"> -->
                    <card v-if="false" class="relative">
                        <div class="overlay-card-theme" v-if="!isClientFilterActive">
                            <span class="text-overlay">Please select a client first</span>
                        </div>
                         <el-divider content-position="left" v-if="campaignInformationData.includes('basic')">Basic Information</el-divider> 
                        <div>
                            <el-checkbox  @change="handleCheckAllBasicInformation" v-model="checkAllBasicInformation" class="checkbox__theme">Check All</el-checkbox>
                        </div>
                        <div class="relative grid__container__basic__information">
                            <el-checkbox @change="handleCheckBasicInformation" v-model="listBasicInformation.phone_number" class="checkbox__theme">Phone Number</el-checkbox>
                            <el-checkbox @change="handleCheckBasicInformation" v-model="listBasicInformation.home_address" class="checkbox__theme">Enable Home Address</el-checkbox>
                            <el-checkbox @change="handleCheckBasicInformation" v-model="listBasicInformation.require_email" class="checkbox__theme">Require Email Address</el-checkbox>
                            <el-checkbox v-if="false" v-model="listBasicInformation.gtm" @change="handleCheckBasicInformation" class="checkbox__theme">This code is installed in a Tag Manager</el-checkbox>
                            <div class="overlay-card-theme" v-if="!isClientFilterActive">
                                <span class="text-overlay">Please select a client first</span>
                            </div>
                        </div>
                    </card>
                    <card class="relative" v-if="campaignInformationData.includes('advanced')">
                        <div v-if="isLoadingAdvancedInformation" style="position: absolute; top: 0; bottom: 0; left: 0; right: 0; z-index: 999; background-color: rgba(50,50,50,.9); display: flex; justify-content: center; align-items: center;">
                            <i class="fas fa-spinner fa-spin" style="font-size: 30px;"></i>
                        </div>
                        <div class="overlay-card-theme" v-if="!isClientFilterActive">
                            <span class="text-overlay">Please select a client first</span>
                        </div>
                            <el-divider content-position="left" style="font-size: small; text-align: center; ">Advanced Information</el-divider>
                                <div style="margin-bottom: 10px;" v-if="campaignInformationData.includes('advanced')">
                            </div>
                            <div v-if="campaignInformationData.includes('advanced')">
                                <el-checkbox v-model="checkAllAdvancedInformation" @change="onCheckAllAdvancedInformation" class="checkbox__theme">Check All</el-checkbox>
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 col-lg-4" v-for="(value) in listAdvancedInformation" :key="value.id">
                                        <el-checkbox :label="value.id" v-model="idAdvancedInformation" @change="onCheckItemAdvancedInformation($event, value.id)" class="checkbox__theme">{{ value.name }}</el-checkbox>
                                             <el-popover
                                                  :title="value.name"
                                                  width="220"
                                                  trigger="hover"
                                                  placement="right"
                                            >
                                                  <ul style="list-style-type: disc;">
                                                        <li style="color: #222a42 !important;" v-for="(item, index) in value.description" :key="index">{{ item }}</li>
                                                 </ul>
                                                 <i slot="reference" class="fa fa-question-circle" style="cursor: pointer; margin-left: 8px;"></i>
                                             </el-popover>
                                    </div> 
                                </div> 
                            </div>
                    </card>
                    <card v-if="false" class="relative disabled">
                        <div class="overlay-card-theme">
                            <span class="text-overlay">Coming Soon</span>
                        </div>
                            <el-divider content-position="left" style="font-size: small; text-align: center; " v-if="campaignInformationData.includes('b2b')">Business to Business Information</el-divider>
                                <div style="margin-bottom: 10px;" v-if  ="campaignInformationData.includes('b2b')">
                            </div>
                            <div v-if="campaignInformationData.includes('b2b')">
                                <el-checkbox v-model="checkAllAdvancedInformationB2b" @change="onCheckAllB2bAdvancedInformation" class="checkbox__theme">Check All</el-checkbox>
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 col-lg-4" v-for="(value) in listAdvancedInformationB2b" :key="value.id">
                                        <el-checkbox :label="value.id" v-model="idAdvancedInformationB2b" @change="onCheckItemB2bAdvancedInformation($event, value.id)" class="checkbox__theme">{{ value.name }}</el-checkbox>
                                    </div> 
                                </div> 
                            </div>
                    </card>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-12" style="position: relative;">
                    <div class="overlay-card-theme" v-if="!isClientFilterActive">
                        <span class="text-overlay">Please select a client first</span>
                    </div>
                    <div style="width: 100%;" class="mt-2 mb-4">
                        <card style="margin-bottom: 0px;">
                            <div class="mb-3">
                                <p>Name or Description</p>
                                <base-input
                                    :maxlength="254"
                                    placeholder="Enter label (e.g. MD5 March)"
                                    v-model="nameMD5" style="width: 100%; margin-bottom: 0px !important;">
                                </base-input>
                            </div>
                            <div>
                                <p>MD5 Hash / Email</p>
                                <TextArea
                                    v-model="md5Input"
                                    placeholder="Enter MD5 hashes / Email, one per line"
                                    :rows="6">
                                </TextArea>
                                <div class="d-flex flex-column mt-2">
                                    <small>*You can submit a maximum of 100 MD5 entries.</small>
                                    <small class="mt-1">*Your base price for cost per contact is ${{ costCleanId }}</small>
                                </div>
                            </div>
                            <base-button class="mt-3" :disabled="(!md5Input && md5Input.trim() == '') || isFetchSubmitCleanID" style="height: 40px; width: 100%;" @click="handleSubmit">
                                Submit
                                <i v-if="isFetchSubmitCleanID" class="fas fa-spinner fa-spin ml-2" style="font-size: 16px;"></i>
                            </base-button>
                        </card>
                    </div>
                    <TabsShadcn v-if="false" style="border: 1px solid white;" isTheme v-model="activeTab" :tabs="tabs">
                        <template v-slot:default="{ active }">
                            <div  v-if="active === 'uploadMd5'" style="width: 100%;" class="mt-3">
                                <card style="cursor: pointer; user-select:none;" class="card__upload">
                                    <div @click="triggerUpload" @drop.prevent="onDrop" @dragover.prevent style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
                                        <input
                                            type="file"
                                            ref="fileInput"
                                            style="display: none;"
                                            @change="handleFileInputChange"
                                            accept=".csv"
                                        />
                                        <div style="display: flex; flex-direction: column; align-items: center;">
                                            <i class="el-icon-upload bounce" style="font-size: 100px; color: #409EFF;"></i>
                                            <p style="font-size: 20px; font-weight: 700; margin-bottom: 8px;">Import new file</p>
                                            <p style="opacity: 0.8;">Maximum file size: 10 MB (10K records MAX)</p>
                                            <p style="opacity: 0.8;">Supported format: 
                                                <span style="
                                                    background-color: #409EFF;
                                                    color: white;
                                                    font-weight: 600;
                                                    padding: 2px 8px;
                                                    border-radius: 12px;
                                                    font-size: 12px;
                                                    font-family: monospace;">
                                                        .csv
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                            <div v-else-if="active === 'inputManual'" style="width: 100%;" class="mt-3">
                                <card style="margin-bottom: 0px;">
                                    <div class="mb-3">
                                        <p>Name or Description</p>
                                        <base-input
                                            :maxlength="254"
                                            placeholder="Enter label (e.g. MD5 March)"
                                            v-model="nameMD5" style="width: 100%; margin-bottom: 0px !important;">
                                        </base-input>
                                    </div>
                                    <div>
                                        <p>MD5 Hash</p>
                                        <TextArea
                                            v-model="md5Input"
                                            placeholder="Enter MD5 hashes, one per line"
                                            :rows="6"
                                            >
                                        </TextArea>
                                    </div>
                                    <base-button class="mt-3" :disabled="!md5Input && md5Input.trim() == ''" style="height: 40px; width: 100%;">Submit</base-button>
                                </card>
                            </div>
                        </template>
                    </TabsShadcn>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12" :class="activeTab == 'inputManual' && 'mt-4'">
            <div class="mb-4">
                <p style="font-size: 24px; font-weight: 700;">History</p>
            </div>
            <div class="mb-2">
                <div class="row">
                    <div class="col-12">
                        <div style="display: flex;">
                            <base-input class="input__search__clean__id">
                                <el-input type="search" class="search-input" clearable prefix-icon="el-icon-search"
                                    placeholder="Search" v-model="searchQuery" aria-controls="datatables" @keyup.native.enter="searchKeyWord" @clear="searchKeyWord">
                                </el-input>
                            </base-input>

                            <el-dropdown ref="dropdown" @visible-change="handleVisibleChange">
                                <span>
                                    <base-button class="m-0 ml-2" size="sm" style="height:40px">
                                        <i class="fa-solid fa-filter"></i> Filters
                                    </base-button>
                                </span>
                                <el-dropdown-menu slot="dropdown" style="width: 240px;"  :class="{ 'dropdown-hidden': !dropdownVisible }" @click.native.stop>
                                    <div class='ml-4 mr-4'>
                                        <el-collapse value="Type" style="border: none;">
                                            <el-collapse-item v-if="false" title="Type" name="Type">
                                                <div style="padding-left:8px;">
                                                    <el-radio v-model="filterType" label="">All</el-radio>
                                                    <el-radio v-model="filterType" label="upload">Upload</el-radio>
                                                    <el-radio v-model="filterType" label="manual">Manual</el-radio>
                                                </div>
                                            </el-collapse-item>
                                        </el-collapse>
                                        <el-collapse value="Status" style="border: none;">
                                        <el-collapse-item title="Status" name="Status">
                                            <div style="padding-left:8px; display: flex; flex-direction: column;">
                                                <el-radio v-model="filterStatus" label="">All</el-radio>
                                                <el-radio v-model="filterStatus" label="pending">Pending</el-radio>
                                                <el-radio v-model="filterStatus" label="processed">Processed</el-radio>
                                                <el-radio v-model="filterStatus" label="done">Done</el-radio>
                                            </div>
                                        </el-collapse-item>
                                        </el-collapse>
                                    </div>
                                    <div class='d-flex justify-content-end mr-4'>
                                        <base-button @click="applyFilters" :simple="true" size="sm">
                                            Save
                                        </base-button>
                                    </div>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <card>
                    <el-table
                        :data="tableData"
                        style="width: 100%">
                        <template #empty v-if="isFetchTableData">
                            <i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...
                        </template>
                        <el-table-column
                            prop="date"
                            label="Date"
                            align="center"
                            min-width="160"
                            >
                        </el-table-column>
                        <el-table-column v-if="!isClientFilterActive"
                            prop="user"
                            label="Client"
                            align="center"
                            min-width="160"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="Title / File"
                            align="center"
                            min-width="160"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="module"
                            label="Modules"
                            align="center"
                            min-width="160"
                            >
                             <template slot-scope="scope">
                                <div class="tags__wrapper__custom">
                                    <div class="tag__item__custom"
                                        v-for="(item, index) in scope.row.module"
                                        :key="index"
                                        :class="getColorModule(item)"
                                        style="border-radius: 999px;"
                                    >
                                        {{ capitalize(item) }}
                                    </div>
                                </div>
                             </template>
                        </el-table-column>
                        <el-table-column
                            prop="type"
                            label="Type"
                            align="center"
                            min-width="160"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            label="Status"
                            align="center"
                            min-width="160"
                            >
                            <template slot-scope="scope">
                                <div class="tags__wrapper__custom" style="justify-content: center;">
                                    <div class="tag__item__custom" :class="tagCustomColor(scope.row.status)" style="border-radius: 999px;">
                                        {{ scope.row.status }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="entries"
                            label="Entries"
                            align="center"
                            min-width="160"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="found"
                            label="Found"
                            align="center"
                            min-width="160"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="not_found"
                            label="Not Found"
                            align="center"
                            min-width="160"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="duplicate"
                            label="Duplicate"
                            align="center"
                            min-width="160"
                            >
                        </el-table-column>
                        <el-table-column 
                            label="Actions" 
                            min-width="160"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <el-tooltip content="Download" placement="top">
                                    <el-button
                                        :disabled="scope.row.status != 'Done'"
                                        style="background-color: transparent !important;"
                                        icon="el-icon-download"
                                        size="mini"
                                        circle
                                        class="icon__button custom__icon__btn"
                                        :class="scope.row.status != 'Done' && 'disabled'"
                                        @click="onDownloadFile(scope.row.id, scope.row.name)"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip v-if="false" content="Download By Job" placement="top">
                                    <el-button
                                        style="background-color: transparent !important;"
                                        :icon="loadingExportId === scope.row.id ? 'el-icon-loading' : 'el-icon-time'"
                                        size="mini"
                                        circle
                                        class="icon__button custom__icon__btn"
                                        :loading="loadingExportId === scope.row.id"
                                        :disabled="loadingExportId === scope.row.id"
                                        @click="onDownloadBackgroundFile(scope.row.id, scope.row.name)"
                                    ></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </card>
            </div>
        </div>

        <modal :show.sync="modals.financialSettings" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Financial Settings</h4>
            <div class="row">
                <div v-if="false" class="col-12 mb-2">
                    <el-card class="mb-3 opacity-75 rounded shadow-none">
                        <p style="font-size: 18px; font-weight: 600; margin-bottom: 0px;"><span style="opacity: 0.7;">Your balance : </span> ${{ balanceDirectPayment }} </p>
                    </el-card>
                    <el-card shadow="never">
                        <p style="margin-bottom: 0px;"><span style="font-weight: 600;">Continual top up</span> will automatically top up your pool of pre-purchased contacts when it reaches zero.</p>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6" style="padding-top: 16px;">
                                <base-button 
                                style="max-width: 250px;"
                                class="text-white bg-danger"
                                >
                                    <span>Stop Continual Top Up</span>
                                </base-button>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6" style="padding-block: 16px;">
                                <p style="margin-bottom: 0px; font-weight: 600;">
                                    Automatic top-up will occur when your pre-purchased amount drops below 10% of last your balance
                                </p>
                            </div>
                        </div>

                    </el-card>
                    <el-card class="mt-3 shadow-none p-3">
                        <p style="font-weight: 600;">Choose amount :</p>
                        <div class="row">
                            <div class="col-12 col-sm-6 col-md-4 p-3" v-for="(data , index) in choseAmount" :key="index">
                                <div class="text-center cursor-pointer">
                                    <el-card :shadow="!customAmountDirectPayment ? (activeIndexAmount === data.id ? 'always' : 'hover') : 'never'" class="cursor-pointer" :class="[activeIndexAmount === data.id ? 'active-amount' : '',  customAmountDirectPayment ? 'disabled-card' : '']" @click.native="onActiveIndexAmount(data)">
                                        <i class="fas fa-money-check-alt" style="font-size: 20px;"></i>
                                        <p style="font-weight: 600;">${{ data.amount }}</p>
                                </el-card>
                            </div>
                        </div>
                         <div class="ml-2 mt-4 p-2" style="width: 100%;">
                             <el-checkbox v-model="customAmountDirectPayment">Custom amount</el-checkbox>
                                 <base-input
                                      addon-left-icon="fas fa-dollar-sign"
                                      type="text"
                                      :class="!customAmountDirectPayment && 'disabled'" 
                                      aria-placeholder="0"
                                      v-model="amountDirectPayment"
                                      @keydown="restrictInput"
                                      @blur="blurInputAmountDirectPayment"
                                      @keyup="keyupInputAmountDirectPayment"
                                      @copy.prevent 
                                      @cut.prevent
                                      @paste.prevent
                                      class="campaign-cost-input mt-2"
                                      ></base-input>
                                     <div v-if="errMinimumAmountDirectPayment" style="color:#942434; font-size: .75rem;">
                                   <span>*Minimum amount is {{ minimumAmountDirectPayment }}</span>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </div>
                <div class="col-12 mt-2 mb-2">
                    <div>
                        <p class="client-payment-modal-form-label">
                            Cost per contact (Basic)
                            <sup style="cursor: pointer;">
                                <el-tooltip
                                    :content="helpContentMap[0].desc"
                                    effect="light"
                                    :open-delay="300"
                                    placement="top"
                                    popper-class="tooltip-content">
                                    <span style="font-size: 12px;"><i class="fa fa-question-circle"></i></span>
                                </el-tooltip>
                            </sup>
                        </p>
                        <base-input
                            style="margin-bottom: 0px;"
                            type="text"
                            placeholder="0"
                            addon-left-icon="fas fa-dollar-sign"
                            class="campaign-cost-input"  
                            v-model="cleanCostperlead"
                            @keydown="restrictInput"
                            @keyup="validateCostPerLeadKeyup('basic')"
                            @blur="validateCostPerLeadBlur('basic')"
                            @copy.prevent @cut.prevent @paste.prevent>
                        </base-input>
                        <small v-if="false">Your base price for cost per contact is $1.25</small>
                        <span v-if="errCleanCostPerLead" class="clean-cost-text-error">Cost per contact basic must be above 0</span>
                    </div>
                    <div class="mt-4">
                        <p class="client-payment-modal-form-label">
                            Cost per contact (Advanced)
                            <sup style="cursor: pointer;">
                                <el-tooltip
                                    :content="helpContentMap[0].desc"
                                    effect="light"
                                    :open-delay="300"
                                    placement="top"
                                    popper-class="tooltip-content">
                                    <span style="font-size: 12px;"><i class="fa fa-question-circle"></i></span>
                                </el-tooltip>
                            </sup>
                        </p>
                        <base-input
                            style="margin-bottom: 0px;"
                            type="text"
                            placeholder="0"
                            addon-left-icon="fas fa-dollar-sign"
                            class="campaign-cost-input"  
                            v-model="cleanCostperleadAdvanced"
                            @keydown="restrictInput"
                            @keyup="validateCostPerLeadKeyup('advanced')"
                            @blur="validateCostPerLeadBlur('advanced')"
                            @copy.prevent @cut.prevent @paste.prevent>
                        </base-input>
                        <small v-if="false">Your base price for cost per contact is $1.25</small>
                        <span v-if="errCleanCostperleadAdvanced" class="clean-cost-text-error">Cost per contact advanced must be above 0</span>
                    </div>
                    <div v-if="false" class="mt-3">
                        <el-timeline>
                            <el-timeline-item color="#222a42" icon="el-icon-bottom-right" size="large" timestamp="Advanced Markup" placement="top">
                                <div>
                                    <div style="width: 100%;">
                                        <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                            class="campaign-cost-input"
                                            @keydown="restrictInput"  @copy.prevent @cut.prevent @paste.prevent>
                                        </base-input>
                                    </div>
                                </div>
                                <div class="client-payment-modal-form-helper-text">
                                    <span>Your base price $1</span>
                                </div>
                            </el-timeline-item>
                            <el-timeline-item class="timeline-item-wrapper" color="#222a42" icon="el-icon-bottom-right" size="large" timestamp="Business Markup" placement="top">
                                <div class="overlay-timeline">
                                    <p class="text-overlay" style="color: #222a42;">Coming Soon</p>
                                </div>

                                <div>
                                    <div style="width: 100%;">
                                        <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                            class="campaign-cost-input"
                                            @keydown="restrictInput"  @copy.prevent @cut.prevent @paste.prevent>
                                        </base-input>
                                    </div>
                                </div>
                                <div class="client-payment-modal-form-helper-text">
                                    <span>Your base price $1</span>
                                </div>
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </div>
                <div v-if="false" class="col-12 mt-3 mb-3">
                    <TabsShadcn v-model="activeTabFinancial" :tabs="tabsFinancial">
                        <template v-slot:default="{ active }">
                            <div v-if="active == 'calculations'" style="width: 100%;" class="mt-3">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <div style="border:solid 1px;opacity:0.5; width:100%">&nbsp;</div>
                                    </div>
                                    <div class="col-6">
                                        <div style="display: flex; flex-direction: column;">
                                            <small>Client Calculations</small>
                                            <small><strong>Pricing Summary:</strong>
                                                <ul style="margin-bottom: 0px;">
                                                    <li style="color: #525f7f !important;">Your Cost per contact is $<strong>1</strong></li>
                                                    <li style="color: #525f7f !important;">Advanced Markup: +$<strong>1</strong> <i class="el-icon-success" style="color: green;"></i></li>
                                                    <li style="color: #525f7f !important;">Business to Business Information: +$<strong>2</strong> <i class="el-icon-success" style="color: green;"></i></li>
                                                    <li style="color: #525f7f !important;">Total Cost per Contact: $<strong>2</strong></li>
                                                </ul>
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-6" v-if="userData.user_type != 'client'">
                                        <div style="display: flex; flex-direction: column;">
                                            <small>Agency Calculations</small>
                                            <small><strong>Pricing Summary:</strong>
                                                <ul style="margin-bottom: 0px;">
                                                    <li style="color: #525f7f !important;">Your Cost per contact is $<strong>1</strong></li>
                                                    <li style="color: #525f7f !important;">Advanced Markup: +$<strong>1</strong> <i class="el-icon-success" style="color: green;"></i></li>
                                                    <li style="color: #525f7f !important;">Business to Business Information: +$<strong>2</strong> <i class="el-icon-success" style="color: green;"></i></li>
                                                    <li style="color: #525f7f !important;">Total Cost per Contact: $<strong>2</strong></li>
                                                </ul>
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="active == 'history'" style="width: 100%;" class="mt-3 mb-3">
                                <el-card shadow="never">
                                    <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
                                        <p style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">History</p>
                                        <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                                            <div>
                                                <el-date-picker type="month" placeholder="Pick a month" :editable="false"></el-date-picker>
                                            </div>
                                            <base-button size="sm" style="height:40px;">
                                                <i class="fas fa-cloud-download-alt pr-2"></i> Download Data
                                            </base-button>
                                        </div>
                                    </div>
                                    <div v-if="false">
                                        <div style="min-height: 6vh; display: flex; justify-content: center; align-items: center;">
                                            <i class="fas fa-spinner fa-spin" style="font-size: 20px;"></i>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div style="margin-top: 16px; overflow-y: auto; max-height: 320px;" v-if="transactionHistoryDirectPayment.length > 0">
                                            <div v-for="item in transactionHistoryDirectPayment" :key="item.id" style="padding-right: 10px;">
                                                <div style="display: flex; justify-content: space-between; gap: 16px; align-items: center;">
                                                    <div style="display: flex; flex-direction: column;">
                                                        <p style="margin-bottom: 0px; font-weight: 600;">{{ item.title }}</p>
                                                        <span style="opacity: 0.8;">{{ item.created_at }}</span>
                                                    </div>
                                                    <div>
                                                        <p :style="'font-weight: 600; color: ' + getColorTransaction(item.transaction_type) + ' !important;'">${{ item.amount }}</p>
                                                    </div>
                                                </div>
                                                <div style="border-top: 1px solid #ccc; margin: 16px 0;"></div>
                                            </div>
                                        </div>
                                        <div style="margin-top: 16px; display: flex; justify-content: center; align-items: center;" v-else>
                                            <p>No transaction history available.</p>
                                        </div>
                                    </div>
                                </el-card>
                            </div>
                        </template>
                    </TabsShadcn>
                </div>
                <div class="col-12 mt-3">
                    <div class="row">
                        <div v-if="false" class="col-12 mb-3">
                            <div style="border:solid 1px;opacity:0.5; width:100%">&nbsp;</div>
                        </div>
                        <div class="col-12">
                            <base-button 
                                style="width: 100%;" 
                                @click.native="onSaveFinancialSettingsClean"
                                :disabled="isSaveFinancialSettings">
                                Save
                                <i v-if="isSaveFinancialSettings" class="fas fa-spinner fa-spin ml-2" style="font-size: 16px;"></i>
                            </base-button>
                        </div>
                        <div v-if="false" class="col-6">
                            <base-button style="width: 100%;">Pay $10</base-button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { Upload, Button, Table, TableColumn, Tooltip, Card, Divider, Input, Dropdown, DropdownMenu, Collapse, CollapseItem, Radio, Tag , Checkbox, DatePicker, Timeline, TimelineItem , Popover} from 'element-ui'
import { TabsShadcn, TextArea, Modal } from 'src/components'
import SelectClientDropdownDashboard from '@/components/SelectClientDropdownDashboard.vue'
import axios from 'axios';
import { downloadFileInBackground } from '../../../../helpers/downloadFile'
import Swal from 'sweetalert2';

export default {
    components: {
        [Upload.name]: Upload,
        [Button.name]: Button,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Tooltip.name]: Tooltip,
        [Card.name]: Card,
        [Divider.name]: Divider,
        [Input.name]: Input,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Radio.name]: Radio,
        [Tag.name]: Tag,
        [Checkbox.name] : Checkbox,
        [DatePicker.name] : DatePicker,
        [Timeline.name] : Timeline,
        [TimelineItem.name] : TimelineItem,
        [Popover.name] : Popover,
        TabsShadcn,
        TextArea,
        Modal,
        SelectClientDropdownDashboard,
    },
    data() {
        return {
            helpContentMap: [
                {
                    desc: 'Clean ID can use either Basic information or Advanced information, similar to Enhance ID. You must set the retail price for each of these data options independently of each other.',
                },
                {
                    desc: 'Clean ID can use either Basic information or Advanced information, similar to Enhance ID. You must set the retail price for each of these data options independently of each other.',
                },
            ],
            loadingExportId: null,
            activeTab: 'uploadMd5',
            tabs: [
                { label: 'Upload MD5', value: 'uploadMd5' },
                { label: 'Input Manual', value: 'inputManual' },
            ],
            activeTabFinancial: 'calculations',
            tabsFinancial: [
                { label: 'Calculations', value: 'calculations' },
                { label: 'History', value: 'history' },
            ],
            nameMD5: '',
            md5Input: '',
            tableDataView: [],
            tableData: [],
            modals: {
                financialSettings: false,
            },
            cleanCostperlead: 0,
            cleanCostperleadAdvanced: 0,
            errCleanCostPerLead: false,
            errCleanCostperleadAdvanced: false,
            userData: {},
            searchQuery: '',
            searchQueryView: '',
            dropdownVisible: false,
            filterType: '',
            filterStatus: '',
            isClientFilterActive: false,
            clientID: '',
            campaignInformationData: ['advanced'],
            isFetchFinancialSettings: false,
            isFetchBalanceAmount: false,
            isSaveFinancialSettings: false,
            isLoadingAdvancedInformation : false,
            isErrorAdvancedInformation: false,
            listAdvancedInformation : [],
            listAdvancedInformationB2b : [],
            isFetchSubmitCleanID: false,
            isFetchTableData: false,
            isLoadingAdvancedInformationB2b : false,
            isErrorAdvancedInformationB2b : false ,
            checkAllAdvancedInformation: false,
            checkAllAdvancedInformationB2b: false,
            idAdvancedInformation: [],
            idAdvancedInformationB2b: [],
            checkAllBasicInformation : false ,
            minimumAmountDirectPayment : 0,
            errMinimumAmountDirectPayment : false,
            costCleanId: 0,
            totalAmountDirectPayment : 0,
            lastBalanceAmountDirectPayment : 0 ,
            amountDirectPayment : 0,
            balanceDirectPayment : 10,
            customAmountDirectPayment : false,
            choseAmount : [
                {
                    id : 1 ,
                    amount : 250,
                },
                {
                    id : 2 ,
                    amount : 500,
                },
                {
                    id : 3 ,
                    amount : 1000,
                }
            ],
            activeIndexAmount: 0 ,
            listBasicInformation :  {
                phone_number : true,
                home_address : true,
                require_email : true,
                gtm : false 
            },
            transactionHistoryDirectPayment: [],
            costagency : {
                local : {
                    'Weekly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    },
                    'Monthly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    },
                    'OneTime' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                }
                },

                locator : {
                    'Weekly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    },
                    'Monthly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    },
                    'OneTime' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    }
                },

                enhance : {
                    'Weekly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    },
                    'Monthly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    },
                    'OneTime' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    }
                },

                b2b : {
                    'Weekly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    },
                    'Monthly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    },
                    'OneTime' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    }
                },

                clean : {
                    CleanCostperlead: "0.5",
                    CleanCostperleadAdvanced: "1",
                }
            },
        }
    },
    // activated() {
    //     const storedId = localStorage.getItem('clean_id_export_id');
    //     if (storedId && !this.loadingExportId) {
    //     this.loadingExportId = parseInt(storedId);
    //     this.pollExportStatus(storedId);
    //     }
    // },
    methods: {
        getBalanceDataWallet() {
            this.isFetchBalanceAmount = true;
            this.$store.dispatch('getBalanceDataWallet', {
                companyID: this.userData.company_id,
            })
            .then(response => {
                // console.log(response);
                this.$global.balanceDirectPayment = response.balance_amount;
                this.isFetchBalanceAmount = false;
            })
            .catch(error => {
                console.error(error);
                this.isFetchBalanceAmount = false;
            })
        },
        GetCostAgency() {
            this.$store.dispatch('getGeneralSetting', {
                companyID: this.userData.company_id,
                settingname: 'costagency',
                idSys: this.$global.idsys
            })
            .then(response => {
                // console.log(response);
                this.costagency = response.data;
                this.costCleanId = this.costagency.clean.CleanCostperlead;
                if(this.campaignInformationData.includes('advanced')) {
                    this.costCleanId = this.costagency.clean.CleanCostperleadAdvanced;
                }
            })
            .catch(error => {
                console.error(error);
            });
        },
        handleSubmit() {
            // validation
            if(!this.nameMD5 || this.nameMD5.trim() == '') {
                this.$notify({
                    type: 'danger',
                    message: 'Input Name MD5 Required',
                    icon: 'fas fa-bug'
                });
                return;
            }
            if(!this.md5Input || this.md5Input.trim() == '') {
                this.$notify({
                    type: 'danger',
                    message: 'Input MD5 Required',
                    icon: 'fas fa-bug'
                });
                return;
            }
            if(
                this.listBasicInformation.phone_number === false && 
                this.listBasicInformation.home_address === false && 
                this.listBasicInformation.require_email === false
            ) {
                this.$notify({
                    type: 'danger',
                    message: 'Basic information must be selected at least 1',
                    icon: 'fas fa-bug'
                });
                return;
            }
            // validation

            const activeCampaigns = this.campaignInformationData.filter(c => ['basic', 'advanced'].includes(c)).join(','); // hasilnya: 'basic,advanced'
            // console.log(activeCampaigns);
            
            // validation
            const activeCampaignArray = activeCampaigns.split(',');
            if(activeCampaignArray.includes('advanced') && this.idAdvancedInformation.length == 0) {
                this.$notify({
                    type: 'danger',
                    message: 'Advanced information must be selected at least 1',
                    icon: 'fas fa-bug'
                });
                return;
            }
            // validation

            this.isFetchSubmitCleanID = true;
            this.$store.dispatch('submitCleanID', {
                companyID: this.userData.company_id,
                module: activeCampaigns,
                phone_number: this.listBasicInformation.phone_number,
                home_address: this.listBasicInformation.home_address,
                require_email: this.listBasicInformation.require_email,
                advanced_information: this.idAdvancedInformation,
                file_name: this.nameMD5,
                md5: this.md5Input
            })
            .then(response => {
                // console.log(response);
                this.nameMD5 = '';
                this.md5Input = '';
                this.isFetchSubmitCleanID = false;
                this.$global.balanceDirectPayment = response.balance_amount;

                this.GetDataFile();
                this.$notify({
                    type: 'success',
                    message: 'Submit md5 successfully',
                    icon: 'fas fa-save'
                });
            })
            .catch(error => {
                console.error(error);
                const errorType = typeof(error.response.data.error_type) != 'undefined' ? error.response.data.error_type : '';
                const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something wrong, please try again';
                
                this.isFetchSubmitCleanID = false;
                if(errorType == 'insufficient_funds') {
                    Swal.fire({
                        title: 'Insufficient Balance',
                        text: message,
                        icon: "error",
                        customClass: {
                            confirmButton: 'btn btn-fill mr-3',
                            cancelButton: 'btn btn-danger btn-fill'
                        },
                        confirmButtonText: 'Top Up Now',
                        buttonsStyling: false
                    })
                    .then(result => {
                        if(result.isConfirmed) {
                            this.$global.modals.directPayment = true;
                        }
                    })
                } else {
                    this.$notify({
                        type: 'danger',
                        message: message,
                        icon: 'fas fa-bug'
                    });
                }
            })
        },
        triggerUpload() {
            this.$refs.fileInput.click();
        },
        handleUpload(file) {
            if (!file) return;
            const isCSV = file.type === 'text/csv' || file.name.toLowerCase().endsWith('.csv');

            if (!isCSV) {
                this.$notify({
                    type: 'danger',
                    message: 'Only CSV files are allowed.',
                    icon: 'fa-solid fa-circle-exclamation'
                })
                return;
            }
            // console.log('File received:', file);
            // console.log('Client ID:', this.clientID);

            
            const activeCampaigns = this.campaignInformationData.filter(c => ['basic', 'advanced'].includes(c)).join(', ');
            // console.log('Aktif:', activeCampaigns); // hasilnya: ['basic', 'advanced']
            // console.log(this.idAdvancedInformation); 
            
            const formData = new FormData();
            formData.append('file', file);
            // formData.append('userid', this.$store.getters.userData.id);
            formData.append('userid', this.clientID);
            formData.append('module', activeCampaigns);

            formData.append('phone_number', this.listBasicInformation.phone_number);
            formData.append('home_address', this.listBasicInformation.home_address);
            formData.append('require_email', this.listBasicInformation.require_email);
            formData.append('gtm', this.listBasicInformation.gtm);
            formData.append('advance_information', this.idAdvancedInformation);

            const config = {
                headers: {
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin' : '*',
                }
            };

            axios.post(process.env.VUE_APP_APISERVER_URL + '/api/tools/clean-id/upload', formData, config)
            .then(response => {
                this.$notify({
                    type: 'success',
                    message: 'File uploaded, processing started.',
                    icon: 'fa-solid fa-check-circle'
                });
            })
            .catch(error => {
                this.$notify({
                    type: 'danger',
                    message: 'Upload failed.',
                    icon: 'fa-solid fa-times-circle'
                });
                console.error(error);
            })

            this.GetDataFile()

        },
        handleFileInputChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.handleUpload(file);
            }
        },
        onDrop(event) {
            event.preventDefault();
            const files = event.dataTransfer.files;
            if (files.length !== 1) {
                this.$notify({
                    type: 'danger',
                    message: 'Please drop only one file.',
                    icon: 'fa-solid fa-circle-exclamation'
                });
                return;
            }
                
            if (files.length) {
                this.handleUpload(files[0]);
            }
        },
        validateCostPerLeadBlur(type) {
            if (type == 'basic') {
                if (this.cleanCostperlead == '' || Number(this.cleanCostperlead) <= 0) {
                    this.cleanCostperlead = 1;
                    this.errCleanCostPerLead = false
                }
            } else if (type == 'advanced') {
                if (this.cleanCostperleadAdvanced == '' || Number(this.cleanCostperleadAdvanced) <= 0) {
                    this.cleanCostperleadAdvanced = 1;
                    this.errCleanCostperleadAdvanced = false;
                }
            }
        },
        validateCostPerLeadKeyup(type) {
            if (type == 'basic') {
                this.errCleanCostPerLead = (Number(this.cleanCostperlead) <= 0);
            } else if (type == 'advanced') {
                this.errCleanCostperleadAdvanced = (Number(this.cleanCostperleadAdvanced) <= 0);
            }
        },
        onOpenFinancialSettingsClean(){
            this.isFetchFinancialSettings = true;
            const userData = this.$store.getters.userData;

            this
            .$store
            .dispatch('getFinancialSettingsClean', {
                companyID: userData.company_id
            })
            .then(response => {
                // console.log(response);
                this.cleanCostperlead = typeof(response.cleanCostperlead) != 'undefined' ? response.cleanCostperlead : 0;
                this.cleanCostperleadAdvanced = typeof(response.cleanCostperleadAdvanced) != 'undefined' ? response.cleanCostperleadAdvanced : 0;
                this.isFetchFinancialSettings = false;
                this.modals.financialSettings = true;
            })
            .catch(error => {
                const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : "Something went wrong please try again later";
                this.$notify({ type: 'danger', message: message, icon: 'fa-solid fa-circle-exclamation' });
                this.isFetchFinancialSettings = false;
            });
        },
        onSaveFinancialSettingsClean() {
            this.isSaveFinancialSettings = true;
            const userData = this.$store.getters.userData;

            this
            .$store
            .dispatch('saveFinancialSettingsClean', {
                companyID: userData.company_id,
                cleanCostperlead: this.cleanCostperlead,
                cleanCostperleadAdvanced: this.cleanCostperleadAdvanced,
            })
            .then(response => {
                this.$notify({ type: 'success', message: 'Data has been updated successfully', icon: 'far fa-save' });
                this.modals.financialSettings = false;
                this.isSaveFinancialSettings = false;
            })
            .catch(error => {
                const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : "Something went wrong please try again later";
                this.$notify({ type: 'danger', message: message, icon: 'fa-solid fa-circle-exclamation' });
                this.isSaveFinancialSettings = false;
            });
        },
        searchKeyWord() {
            this.GetDataFile();
        },
        handleVisibleChange(visible) {            
            this.dropdownVisible = visible;
        },
        applyFilters(){
            this.GetDataFile();
        },
        onDownloadFile(id, filename){
            const nameWithoutExt = filename.split('.').slice(0, -1).join('.');
            const url = process.env.VUE_APP_DATASERVER_URL + '/configuration/clean-id/download-result/' + id ;
            downloadFileInBackground(url, 'result_clean_id_'+nameWithoutExt+'.csv');
        },
        onDownloadBackgroundFile(id, filename){
            let clientID = this.clientID;
            this.loadingExportId = id;

            this.$notify({
                type: 'info',
                message: 'Exporting file, please wait...',
                icon: 'tim-icons icon-bell-55'
            });  

            // //// versi API
            // axios.get(process.env.VUE_APP_APISERVER_URL + '/api/tools/clean-id/download-result-cleanid/' + id + '/' + clientID)
            // .then(response => {
            //     const expId = response.data.export_id;
            //     localStorage.setItem('clean_id_export_id', expId);

            //     this.$nextTick(() => {
            //         this.$root.$emit('startPolling', expId);
            //     });
            // })
            // .catch(error => {
            //     this.loadingExportId = null;
            //     this.$notify({
            //         type: 'danger',
            //         message: 'Failed to start export.',
            //         icon: 'fas fa-exclamation-circle'
            //     });  
            // })

            //// versi APP
            this.$store.dispatch('DownloadResultCleanID', {
                    id, clientID, filename
                })
                .then(response => {
                    // this.tableData = response.data;
                    const expId = response.data.export_id;
                    // Simpan ke localStorage
                    localStorage.setItem('clean_id_export_id', expId);
                    // this.pollExportStatus(expId);

                    // let userData = JSON.parse(localStorage.getItem('userData'));
                    // if (userData && typeof userData === 'object') {
                    //     userData.clean_id_export_id = expId;
                    //     localStorage.setItem('userData', JSON.stringify(userData));
                    // }

                    //// panggil ke app.vue biar global
                    // this.$root.$emit('startPolling', expId);
                    this.$nextTick(() => {
                        this.$root.$emit('startPolling', expId);
                    });
                })
                .catch(error => {
                    // this.tableData = [];
                    this.loadingExportId = null;
                    this.$notify({
                        type: 'danger',
                        message: 'Failed to start export.',
                        icon: 'fas fa-exclamation-circle'
                    });  
                });
        },
        // pollExportStatus(exportId) {
        //     const interval = setInterval(() => {
        //     axios.get(`/leadspeek/clean-id/export-status/${exportId}`)
        //         .then(res => {
        //             if (res.data.status === 'done') {
        //                 clearInterval(interval);

        //                 // Auto-download file ketika status 'done'
        //                 const downloadUrl = res.data.download_url;
        //                 if (downloadUrl) {
        //                     const link = document.createElement('a');
        //                     link.href = downloadUrl;
        //                     link.download = '';
        //                     document.body.appendChild(link);
        //                     link.click();
        //                     document.body.removeChild(link);
        //                 }

        //                 // Hapus exportId dari localStorage
        //                 localStorage.removeItem('clean_id_export_id');
        //                 this.loadingExportId = null; 

        //                 this.$notify({
        //                     type: 'success',
        //                     message: 'Exporting file success.',
        //                     icon: 'fas fa-check'
        //                 });  
                        
        //             }
        //         })
        //         .catch(err => {
        //             console.error('Error checking export status:', err);
        //             clearInterval(interval);
        //             this.loadingExportId = null;
        //         });
        //     }, 2000);
        // },
        restrictInput(event) {
            const input = event.target.value;
            const char = event.key;

            if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
                return; 
            }

            if (!char.match(/[0-9]/) && char !== '.') {
                event.preventDefault();
            }

            // Allow only one period
            if (char === '.' && input.includes('.')) {
                event.preventDefault();
            }
        },
        onActiveIndexAmount(value) {
            if(!this.customAmountDirectPayment) {
                this.amountDirectPayment = value.amount;
                this.activeIndexAmount = value.id;
            } else {
                this.activeIndexAmount = 0;
            }
        },
        blurInputAmountDirectPayment() {
            if(Number(this.amountDirectPayment) < Number(this.minimumAmountDirectPayment)) {
                this.amountDirectPayment = this.minimumAmountDirectPayment;
            } 
            this.errMinimumAmountDirectPayment = false;
        },
        keyupInputAmountDirectPayment() {
            if(Number(this.amountDirectPayment) < Number(this.minimumAmountDirectPayment)) {
                this.errMinimumAmountDirectPayment = true;
            } else {
                this.errMinimumAmountDirectPayment = false;
            }

            const chooseAmount =  this.chooseAmount.find(item => item.amount == this.amountDirectPayment);
            this.activeIndexAmount = chooseAmount ? chooseAmount.id : 0;
        },
        onCheckAllAdvancedInformation(value){
            const allIdAdvancedInformation = this.listAdvancedInformation.map((item) => item.id)
           
            if(value){
                this.idAdvancedInformation = allIdAdvancedInformation;
            } else {
                this.idAdvancedInformation = []
            }
        },
        onCheckItemAdvancedInformation(value, id) {
            const allIdAdvancedInformation = this.listAdvancedInformation.map((item) => item.id)
            if(value){
                // dont remove this code
            } else {
                const idFilter = this.idAdvancedInformation.filter((item) => item !== id)
                this.idAdvancedInformation = idFilter;
            }

            this.checkAllAdvancedInformation = this.idAdvancedInformation.length == allIdAdvancedInformation.length
        },
        onCheckAllB2bAdvancedInformation(value){
            const allIdAdvancedInformationB2b = this.listAdvancedInformationB2b.map((item) => item.id)    
            if(value){
                this.idAdvancedInformationB2b = allIdAdvancedInformationB2b;
            } else {
                this.idAdvancedInformationB2b = []
            }
        },
        onCheckItemB2bAdvancedInformation(value , id){
            const allIdAdvancedInformationB2b = this.listAdvancedInformationB2b.map((item) => item.id)
            
            if(value){
                // dont remove this code
            } else {
               const idFilterB2b = this.idAdvancedInformationB2b.filter((item) => item !== id)
               this.idAdvancedInformationB2b = idFilterB2b;
            }

            this.checkAllAdvancedInformationB2b = this.idAdvancedInformationB2b.length == allIdAdvancedInformationB2b.length
        },
      
        tagCustomColor(value){
            switch (value) {
                case 'Pending':
                    return 'tag__item__pending';
                case 'Process':
                    return 'tag__item__process';
                case 'Done':
                    return 'tag__item__success';
                case 'Error':
                    return 'tag__item__warning';
                default:
                    return '';
            }
        },
        GetListAdvanceInformation() {
            this.isLoadingAdvancedInformation = true;
            this.isErrorAdvancedInformation = false,
            this.$store.dispatch('GetListAdvanceInformation')
                .then(response => {
                    this.listAdvancedInformation = response.listAdvanceInformation;
                    this.listAdvancedInformation.forEach((item, index) => {
                        if(item.type == 'contactInformation') {
                            this.listAdvancedInformation[index].description.unshift("Phone1", "Phone2");
                        }
                        this.idAdvancedInformation.push(item.id); 
                    });
                    this.checkAllAdvancedInformation = true;
                    this.isLoadingAdvancedInformation = false;
                })
                .catch(error => {
                    this.isLoadingAdvancedInformation = false;
                    this.isErrorAdvancedInformation = true
                });
        },
        GetListAdvanceInformationB2b() {
            this.isLoadingAdvancedInformationB2b = true;
            this.isErrorAdvancedInformationB2b = false,
            this.$store.dispatch('GetListAdvanceInformationB2B')
                .then(response => {
                    this.listAdvancedInformationB2b = response.listAdvanceInformation;

                    this.listAdvancedInformationB2b.forEach((item, index) => {
                        if(item.type == 'contactInformation') {
                            this.listAdvancedInformationB2b[index].description.unshift("Phone1", "Phone2");
                        }
                    });
                    
                    this.isLoadingAdvancedInformationB2b = false;
                })
                .catch(error => {
                    this.isLoadingAdvancedInformationB2b = false;
                    this.isErrorAdvancedInformationB2b = true
                });
        },
        GetDataFile() {
            let companyID = this.userData.company_id;
            this.tableData = [];
            this.isFetchTableData = true;
            this.$store.dispatch('GetDataFile', {
                companyID: companyID,
                searchkey: this.searchQuery,
                filterStatus: this.filterStatus
            })
            .then(response => {
                // console.log(response);
                this.isFetchTableData = false;
                this.tableData = response.data;
                this.$global.balanceDirectPayment = response.balance_amount;
            })
            .catch(error => {
                console.error(error);
                this.isFetchTableData = false;
                this.tableData = [];
            });
        },
        GetDataMd5(fileID) {
            let clientID = this.clientID;
            this.$store.dispatch('GetDataMd5', {
                    fileID,
                })
                .then(response => {
                    this.tableDataView = response.data;
                })
                .catch(error => {
                    this.tableDataView = [];
                });
        },
        onChangeFilter(value){
            // if(value){
            //     this.isClientFilterActive = true;
            //     this.clientID = value;
            // } else {
            //     this.isClientFilterActive = false;
            //     this.campaignInformationData = ['basic', 'advanced' , 'b2b']
            //     this.clientID = '';
            // }
            this.isClientFilterActive = true;
            this.clientID = '';
        },
        onChangeCampaignInformationData(type) {
            // validation if user change basic infomation
            if(type == 'basic') {
                this.$notify({
                    type: 'danger',
                    message: 'You Cannot Change Basic Information',
                    icon: 'fa fa-bug'
                });
                return;
            }
            if(type == 'advanced') {
                this.idAdvancedInformation =  [];
            }
            // validation if user change basic infomation

            const index = this.campaignInformationData.indexOf(type);
            if (index > -1) {
                this.campaignInformationData.splice(index, 1);
                this.costCleanId = this.costagency.clean.CleanCostperlead;
            } else {
                this.campaignInformationData.push(type);
                this.costCleanId = this.costagency.clean.CleanCostperleadAdvanced;
            }
        },
        handleCheckAllBasicInformation(value){
            this.listBasicInformation.phone_number = value;
            this.listBasicInformation.home_address = value;
            this.listBasicInformation.require_email = value;
            this.listBasicInformation.gtm = value;
        },
        handleCheckBasicInformation(){
            const {phone_number , home_address , require_email , gtm} = this.listBasicInformation
            if(phone_number && home_address && require_email) {
                this.checkAllBasicInformation = true
            } else {
                this.checkAllBasicInformation = false
            }
        },
        getColorModule(item){
            if(item == 'advanced'){
                return 'badge-advanced'
            } else if(item == 'b2b'){
                return 'badge-b2b'
            } else {
                return 'badge-basic'
            }
        },
        capitalize(value) {
            if (!value) return '';
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    watch: {
        customAmountDirectPayment(newValue) {
            if (newValue) {
                this.amountDirectPayment = 2500;
                this.activeIndexAmount = null; 
            } else {
                this.activeIndexAmount = 1;
                this.amountDirectPayment = 250;
            }
        }
    },
    mounted() {
        this.userData = this.$store.getters.userData;
        this.isClientFilterActive = true;
        this.clientID = this.userData.id;
        
        // if (localStorage.getItem('companyGroupSelected') != null && localStorage.getItem('companyGroupSelected') != '') {
        //     this.isClientFilterActive = true;
        //     this.clientID = Number(localStorage.getItem('companyGroupSelected'));
        // }
        this.getBalanceDataWallet();
        this.GetListAdvanceInformation()
        this.GetListAdvanceInformationB2b()
        this.GetDataFile()
        this.GetCostAgency()

        // const expID = localStorage.getItem('clean_id_export_id');
        // if (expID) {
        //     this.loadingExportId = expID;
        //     this.pollExportStatus(expID);
        // }
    },
}
</script>

<style>
.clean-cost-text-error {
    color:#942434 !important;
    font-size:12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: 8px;
    display: block;
}

.card__upload .card-body {
 padding: 0px !important;
}

.input__search__clean__id {
    width: 400px;
}

.custom-black-text {
  color: black !important;
}

/* .isCheckbox-cleanId {
    color: black;
} */

.isCheckbox-cleanId .el-checkbox__inner {
  background-color: transparent;
  border-color: #686868;
  color: black;
}

.isCheckbox-cleanId.is-checked .el-checkbox__inner {
  background-color: #686868;
  border-color: #686868;
}

.isCheckbox-cleanId.is-checked .el-checkbox__inner::after {
    color: black;
}

.isCheckbox-cleanId.is-checked .el-checkbox__label {
    color: black;
}

.grid__container__basic__information {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

.campaign-cleanid-active {
    border: 1px solid #409EFF;
}

@media (max-width: 1440px) {
    .input__search__clean__id {
        width: 300px;
    }
    .overlay-msg {
         width: 97%;
    }
}

@media (max-width: 992px) {
    .input__search__clean__id {
        width: 300px;
    }
    .overlay-msg {
         width: 96%;
    }
    .grid__container__basic__information {
        grid-template-columns: repeat(1, 1fr);
    }
}

@media (max-width: 768px) {
    .input__search__clean__id {
        width: 300px;
    }
    .overlay-msg {
         width: 96%;
    }
    .grid__container__basic__information {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {
    .input__search__clean__id {
        width: 250px;
    }
    .overlay-msg {
         width: 94%;
    }
    .grid__container__basic__information {
        grid-template-columns: repeat(1, 1fr);
    }
}

.bounce {
  animation: bounce 1s infinite;
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

</style>